"use client";

import { Icon, ospThemes } from "@ospweb/sdk-ui";

import { EdgenAppQRCode } from "./EdgenAppQRCode";
import { EdgenModalCreateAble } from "@/src/components/EdgenModal";
import { I18nUtil } from "@utils/i18n";
import React from "react";
import Translations from "@translate/components/Home/EdgenDownloadModal";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface EdgenDownloadModalContentProps {
  onClose?: () => void;
  className?: string;
}
/**
 * Edgen 下载弹窗内容
 * - 显示下载 Edgen APP 的说明与二维码
 */
const EdgenDownloadModalContent: React.FC<EdgenDownloadModalContentProps> = ({
  onClose,
  className,
}) => {
  return (
    <div className={cn("px-8 pt-12 pb-8", className)}>
      {/* 关闭按钮 */}
      <button
        data-openreplay-label="Close Button"
        id="btn-close-home-edgendownloadmodal-2"
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="absolute right-[14px] top-[14px] text-content_tertiary hover:text-content_secondary transition-colors"
      >
        <Icon
          data-openreplay-label="close"
          className="shrink-0"
          name="close"
          size={24}
          color={ospThemes.colors.content_primary}
          onClick={onClose}
        />
      </button>
      {/* 标题与文案，可以后续接入多语言 */}
      <div className="flex flex-col gap-1 pr-6 text-center">
        <h3
          aria-label="QRCode Component h3"
          data-openreplay-label="QRCode Component h3 Semantic"
          id="sem-qrcode-component-h3"
          className="body_xl text-content_primary"
        >
          {I18n.t("Scan to Download")}
        </h3>
        <p className="headline_regular_s text-content_secondary">
          {I18n.t("Edgen App")}
        </p>
      </div>
      {/* 二维码 */}
      <div className="mt-2 flex justify-center">
        <EdgenAppQRCode
          foregroundColor={ospThemes.colors.content_primary}
          backgroundColor={ospThemes.colors.background_solid_secondary}
          className="bg-background_solid_secondary"
        />
      </div>
    </div>
  );
};

/**
 * EdgenDownloadModalCreateAble
 * - 动态创建 Edgen 下载弹窗
 */
export const EdgenDownloadModalCreateAble = async (): Promise<void> => {
  return new Promise((resolve) => {
    EdgenModalCreateAble.call({
      centered: true,
      // PC 端使用居中 Modal，移动端走 DrawerH5
      children: (
        <EdgenDownloadModalContent
          onClose={() => {
            EdgenModalCreateAble.end(false);
            resolve();
          }}
        />
      ),
      containerStyle: {
        padding: 0,
      },
      contentStyle: {
        padding: 0,
      },
      containerClassName: "md:max-w-[304px] md:w-[304px]",
      destroyOnClose: true,
      onCancel: () => {
        EdgenModalCreateAble.end(false);
        resolve();
      },
    });
  });
};
